import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './store'
import MainLayout from './components/layout/MainLayout.vue'
import PgmLayout from './components/layout/PgmLayout.vue'
import AdminLayout from './components/layout/AdminLayout.vue'
import PwaLayout from './components/pwa/PwaLayout.vue'
import EmpLayout from './components/pwa/EmpLayout.vue'
// Web Pages
import indexPage from './pages/indexPage.vue'
import pgmLogin from './pages/pgm/auth/PgmLogin.vue'
import pgmSignup from './pages/pgm/auth/PgmSignup.vue'
import pgmUserInfo from './pages/pgm/auth/PgmUserInfo.vue'
import pgmDashBoard from './pages/pgm/PgmDashBoard.vue'
import fnaBudgetPage from './pages/fna/BudgetPage.vue'
import fnaInoutPage from './pages/fna/InoutPage.vue'
import fnaBeneficiaryPage from './pages/fna/BeneficiaryPage.vue'
import pgmPayroll from './pages/pgm/PgmPayroll.vue'
import pgmEmployees from './pages/pgm/PgmEmployees.vue'
import PgmNotice from './pages/pgm/PgmNotice.vue'
import PgmNoticeDetail from './pages/pgm/PgmNoticeDetail.vue'
import PgmNoticeWrite from './pages/pgm/PgmNoticeWrite.vue'
import WageProcess from './pages/wage/WageProcess.vue'
// Admin Pages (관리자용)
import AdminMembers from './pages/admin/AdminMembers.vue'
import AdminNotice from './pages/admin/AdminNotice.vue'
import AdminNoticeDetail from './pages/admin/AdminNoticeDetail.vue'
import AdminNoticeWrite from './pages/admin/AdminNoticeWrite.vue'
import AdminPricing from './pages/admin/AdminPricing.vue'
import AdminShop from './pages/admin/AdminShop.vue'
// PWA Pages (센터장/관리자용)
import pwaLogin from './pages/pwa/PwaLogin.vue'
import pwaSignup from './pages/pwa/PwaSignup.vue'
import pwaHome from './pages/pwa/PwaHome.vue'
import pwaUserInfo from './pages/pwa/PwaUserInfo.vue'
import pwaPayroll from './pages/pwa/PwaPayroll.vue'
import pwaFinance from './pages/pwa/PwaFinance.vue'
import pwaReport from './pages/pwa/PwaReport.vue'
import pwaSettings from './pages/pwa/PwaSettings.vue'
import pwaEmployees from './pages/pwa/PwaEmployees.vue'
// Employee Pages (사원용)
import empHome from './pages/emp/EmpHome.vue'
import empPayslip from './pages/emp/EmpPayslip.vue'
import empSchedule from './pages/emp/EmpSchedule.vue'
import empMyInfo from './pages/emp/EmpMyInfo.vue'
import empSettings from './pages/emp/EmpSettings.vue'
import empDocuments from './pages/emp/EmpDocuments.vue'
import empMore from './pages/emp/EmpMore.vue'
import PwaNotice from './pages/pwa/PwaNotice.vue'
import PwaNoticeDetail from './pages/pwa/PwaNoticeDetail.vue'
import EmpNotice from './pages/emp/EmpNotice.vue'
import EmpNoticeDetail from './pages/emp/EmpNoticeDetail.vue'

const routes: readonly RouteRecordRaw[] = [
  // Web Routes
  {
    path: '/',
    component: indexPage,
    name: 'indexPage',
    meta: { layout: MainLayout, requiresAuth: false, isWeb: true }
  },
  {
    path: '/pgm/login',
    component: pgmLogin,
    name: 'pgmLogin',
    meta: { layout: MainLayout, requiresAuth: false, isWeb: true }
  },
  {
    path: '/pgm/signup',
    component: pgmSignup,
    name: 'pgmSignup',
    meta: { layout: MainLayout, requiresAuth: false, isWeb: true }
  },
  // PWA Routes
  {
    path: '/pwa/login',
    component: pwaLogin,
    name: 'pwaLogin',
    meta: { layout: PwaLayout, requiresAuth: false, isPWA: true }
  },
  {
    path: '/pwa/signup',
    component: pwaSignup,
    name: 'pwaSignup',
    meta: { layout: PwaLayout, requiresAuth: false, isPWA: true }
  },
  {
    path: '/pwa/home',
    component: pwaHome,
    name: 'pwaHome',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/notice',
    component: PwaNotice,
    name: 'pwaNotice',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/notice/:ncIdx',
    component: PwaNoticeDetail,
    name: 'pwaNoticeDetail',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/userinfo',
    component: pwaUserInfo,
    name: 'pwaUserInfo',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/payroll',
    component: pwaPayroll,
    name: 'pwaPayroll',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/finance',
    component: pwaFinance,
    name: 'pwaFinance',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/report',
    component: pwaReport,
    name: 'pwaReport',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/settings',
    component: pwaSettings,
    name: 'pwaSettings',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  {
    path: '/pwa/employees',
    component: pwaEmployees,
    name: 'pwaEmployees',
    meta: { layout: PwaLayout, requiresAuth: true, isPWA: true }
  },
  // Employee Routes (사원 전용)
  {
    path: '/emp/home',
    component: empHome,
    name: 'empHome',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/notice',
    component: EmpNotice,
    name: 'empNotice',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/notice/:ncIdx',
    component: EmpNoticeDetail,
    name: 'empNoticeDetail',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/payslip',
    component: empPayslip,
    name: 'empPayslip',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/schedule',
    component: empSchedule,
    name: 'empSchedule',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/myinfo',
    component: empMyInfo,
    name: 'empMyInfo',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/settings',
    component: empSettings,
    name: 'empSettings',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/documents',
    component: empDocuments,
    name: 'empDocuments',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/emp/more',
    component: empMore,
    name: 'empMore',
    meta: { layout: EmpLayout, requiresAuth: true, isPWA: true, isEmployee: true }
  },
  {
    path: '/pgm/notice',
    component: PgmNotice,
    name: 'pgmNotice',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/notice/write',
    component: PgmNoticeWrite,
    name: 'pgmNoticeWrite',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/notice/edit/:ncIdx',
    component: PgmNoticeWrite,
    name: 'pgmNoticeEdit',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/notice/:ncIdx',
    component: PgmNoticeDetail,
    name: 'pgmNoticeDetail',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/dashboard',
    component: pgmDashBoard,
    name: 'pgmDashBoard',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/employees',
    component: pgmEmployees,
    name: 'pgmEmployees',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/userinfo',
    component: pgmUserInfo,
    name: 'pgmUserInfo',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/payroll',
    component: pgmPayroll,
    name: 'pgmPayroll',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/fna/budget',
    component: fnaBudgetPage,
    name: 'fnaBudgetPage',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/fna/inout',
    component: fnaInoutPage,
    name: 'fnaInoutPage',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/fna/beneficiary',
    component: fnaBeneficiaryPage,
    name: 'fnaBeneficiaryPage',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  {
    path: '/pgm/wage/WageProcess',
    component: WageProcess,
    name: 'WageProcess',
    meta: { layout: PgmLayout, requiresAuth: true }
  },
  // Admin Routes (관리자 전용)
  {
    path: '/admin/members',
    component: AdminMembers,
    name: 'adminMembers',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/notice',
    component: AdminNotice,
    name: 'adminNotice',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/notice/write',
    component: AdminNoticeWrite,
    name: 'adminNoticeWrite',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/notice/edit/:ncIdx',
    component: AdminNoticeWrite,
    name: 'adminNoticeEdit',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/notice/:ncIdx',
    component: AdminNoticeDetail,
    name: 'adminNoticeDetail',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/pricing',
    component: AdminPricing,
    name: 'adminPricing',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/shop',
    component: AdminShop,
    name: 'adminShop',
    meta: { layout: AdminLayout, requiresAuth: true, requiresAdmin: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 사용자 타입에 따른 홈 경로 반환
const getHomePathByUserType = (userType: string | null): string => {
  switch (userType) {
    case 'employee':
    case 'boss':
      return '/emp/home';
    case 'manager':
      return '/pwa/home';
    default:
      return '/pwa/home';
  }
};

// 네비게이션 가드 추가
router.beforeEach(async (to, from, next) => {
  const isPWA = store.getters.isPWA;
  let pwaUserType = store.getters['pwa/pwaUserType'];
  let pwaUser = store.getters['pwa/pwaUser'];
  let pwaAuthChecked = store.getters['pwa/pwaAuthChecked'];
  
  // PWA 모드에서 인증 복원이 필요한 경우 (인증 필요 페이지, 로그인 페이지, 루트 경로, 사원 페이지)
  const needsAuthCheck = to.meta.requiresAuth || to.path === '/pwa/login' || to.path === '/' || to.path.startsWith('/emp/');
  
  if (isPWA && !pwaUser && !pwaAuthChecked && needsAuthCheck) {
    store.commit('pwa/setPwaAuthChecked', true);
    try {
      const result = await store.dispatch('pwa/validatePwaAuth');
      if (result.success) {
        // 인증 복원 성공 - 상태 다시 가져오기
        pwaUser = store.getters['pwa/pwaUser'];
        pwaUserType = store.getters['pwa/pwaUserType'];
      }
    } catch (error) {
      console.error('PWA 인증 복원 실패:', error);
    }
  }
  
  // 인덱스 페이지는 로그인 여부와 관계없이 항상 접근 가능
  if (to.path === '/') {
    next();
    return;
  }
  
  // PWA 모드인데 웹 전용 페이지 접근 시 PWA 페이지로 리다이렉트
  if (isPWA && to.meta.isWeb) {
    if (to.path === '/pgm/login') {
      next('/pwa/login');
      return;
    }
    if (to.path === '/pgm/signup') {
      next('/pwa/signup');
      return;
    }
    // 기타 웹 전용 페이지는 PWA 로그인으로 리다이렉트
    next('/pwa/login');
    return;
  }
  
  // 웹 모드인데 PWA/EMP 전용 페이지 접근 시 웹 페이지로 리다이렉트
  if (!isPWA && (to.meta.isPWA || to.meta.isEmployee)) {
    if (to.path === '/pwa/login') {
      next('/pgm/login');
      return;
    }
    if (to.path === '/pwa/signup') {
      next('/pgm/signup');
      return;
    }
    // 기타 PWA 전용 페이지는 웹 로그인으로 리다이렉트
    next('/pgm/login');
    return;
  }
  
  // 사원이 관리자 전용 PWA 페이지 접근 시 사원 홈으로 리다이렉트
  if (isPWA && pwaUser && (pwaUserType === 'employee' || pwaUserType === 'boss')) {
    if (to.path.startsWith('/pwa/') && to.path !== '/pwa/login' && to.path !== '/pwa/signup') {
      next('/emp/home');
      return;
    }
  }
  
  // 관리자가 사원 전용 페이지 접근 시 관리자 홈으로 리다이렉트
  if (isPWA && pwaUser && pwaUserType === 'manager') {
    if (to.path.startsWith('/emp/')) {
      next('/pwa/home');
      return;
    }
  }
  
  // 로그인/회원가입 페이지 처리 (로그인 상태면 홈으로 리다이렉트)
  if (to.path === '/pgm/login' || to.path === '/pgm/signup' ||
      to.path === '/pwa/login' || to.path === '/pwa/signup') {
    
    // 대리 로그인(impersonate) 쿼리 파라미터가 있으면 로그인 페이지 진입 허용
    if (to.query.impersonate) {
      next();
      return;
    }
    
    // PWA 모드에서 이미 로그인된 상태
    if (isPWA && pwaUser) {
      next(getHomePathByUserType(pwaUserType));
      return;
    }
    // 웹 모드에서 이미 로그인된 상태
    if (!isPWA && store.getters.isLoggedIn) {
      // Admin인 경우 관리자 회원관리로, 아니면 일반 페이지로 이동
      if (store.getters.isAdmin) {
        next('/admin/members');
      } else {
        next('/pgm/wage/WageProcess');
      }
      return;
    }
    next();
    return;
  }
  
  // 인증이 필요한 페이지인지 확인
  if (to.meta.requiresAuth) {
    // PWA 모드에서 사원/대표 페이지 접근 시
    if (isPWA && to.meta.isEmployee) {
      if (!pwaUser) {
        next('/pwa/login');
        return;
      }
      // 사원으로 로그인했는지 확인
      if (pwaUserType !== 'employee' && pwaUserType !== 'boss') {
        next('/pwa/home');
        return;
      }
      next();
      return;
    }
    
    // PWA 모드에서 관리자 페이지 접근 시
    if (isPWA && to.meta.isPWA && !to.meta.isEmployee) {
      if (!pwaUser && !store.getters.isLoggedIn) {
        next('/pwa/login');
        return;
      }
      next();
      return;
    }
    
    // 웹 모드 인증 확인
    if (!isPWA) {
      try {
        const isValidAuth = await store.dispatch('validateAuth');
        
        if (!isValidAuth) {
          next('/pgm/login');
          return;
        }
        
        // Admin 전용 페이지 접근 시 권한 확인
        if (to.meta.requiresAdmin) {
          if (!store.getters.isAdmin) {
            next('/pgm/wage/WageProcess');
            return;
          }
        }
      } catch (error) {
        console.error('인증 확인 중 오류:', error);
        next('/pgm/login');
        return;
      }
    }
  }
  
  next();
});

export default router